"use strict";

exports.__esModule = true;
exports.default = Item;
var _preact = require("preact");
var _classnames = _interopRequireDefault(require("classnames"));
var _ItemIcon = _interopRequireDefault(require("./components/ItemIcon.js"));
var _GridLi = _interopRequireDefault(require("./components/GridLi.js"));
var _ListLi = _interopRequireDefault(require("./components/ListLi.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
/* eslint-disable react/require-default-props */

function Item(props) {
  var author = props.author,
    getItemIcon = props.getItemIcon,
    isChecked = props.isChecked,
    isDisabled = props.isDisabled,
    viewType = props.viewType;
  var itemIconString = getItemIcon();
  var className = (0, _classnames.default)('uppy-ProviderBrowserItem', {
    'uppy-ProviderBrowserItem--selected': isChecked
  }, {
    'uppy-ProviderBrowserItem--disabled': isDisabled
  }, {
    'uppy-ProviderBrowserItem--noPreview': itemIconString === 'video'
  });
  var itemIconEl = (0, _preact.h)(_ItemIcon.default, {
    itemIconString: itemIconString
  });
  switch (viewType) {
    case 'grid':
      return (0, _preact.h)(_GridLi.default, _extends({}, props, {
        className: className,
        itemIconEl: itemIconEl
      }));
    case 'list':
      return (0, _preact.h)(_ListLi.default, _extends({}, props, {
        className: className,
        itemIconEl: itemIconEl
      }));
    case 'unsplash':
      return (0, _preact.h)(_GridLi.default, _extends({}, props, {
        className: className,
        itemIconEl: itemIconEl
      }), (0, _preact.h)("a", {
        href: "".concat(author.url, "?utm_source=Companion&utm_medium=referral"),
        target: "_blank",
        rel: "noopener noreferrer",
        className: "uppy-ProviderBrowserItem-author",
        tabIndex: -1
      }, author.name));
    default:
      throw new Error("There is no such type ".concat(viewType));
  }
}